import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector, shallowEqual } from 'react-redux';
import CommentText from '../CommentText/CommentText';
import UserAvatar from '../UserAvatar/UserAvatar';
import CommentTitle from '../CommentTitle/CommentTitle';
import CreatedDate from '../CreatedDate/CreatedDate';
import CommentLabel from '../CommentLabel/CommentLabel';
import { COMMENTS_CONTEXT_SOCIAL_FEED } from '../../utils/constants/commentConstants';
import './CommentDetails.css';
import ConnectedCommentInputContainer from '../../containers/CommentInputContainer/CommentInputContainer';
import { getCommunityName } from '../../store/selectors/community/communitySelectors';
import { getCommentsContext } from '../../store/selectors/settings/settingsSelectors';

const CommentDetails = ({
  body,
  details,
  createdAt,
  parentId,
  isEditing,
  authorIsUser,
  contentId,
  commentId,
  mentionedUsers,
  communityId
}) => {
  const { name, repliedToName, avatar, userId } = details;
  const isReply = Boolean(parentId);
  const commentsContext = useSelector(getCommentsContext, shallowEqual);
  const [inputValue, setInputValue] = useState('');
  const [hasBeenEdited, setHasBeenEdited] = useState(false);
  const communityName = useSelector(
    (state) => getCommunityName(state, communityId),
    shallowEqual
  );
  const isSocialFeedContext =
    commentsContext === COMMENTS_CONTEXT_SOCIAL_FEED && !isReply;
  const getCreatedAtString = () => {
    return !isReply && communityName
      ? `${createdAt} - ${communityName}`
      : createdAt;
  };
  const inputChangeCallBack = (value) => {
    setInputValue(value);
    setHasBeenEdited(true);
  };
  return (
    <div styleName="container">
      <UserAvatar userId={userId} avatar={avatar} authorIsUser={authorIsUser} />
      <div styleName="content">
        {createdAt && !isEditing && (
          <div styleName="detailsContainer">
            {isSocialFeedContext && <CommentLabel type="latest" />}
            <CommentTitle
              userId={userId}
              name={name}
              repliedToName={repliedToName}
              authorIsUser={authorIsUser}
              isReply={isReply}
            />
            <CreatedDate createdAt={getCreatedAtString()} />
          </div>
        )}
        <>
          {isEditing ? (
            <ConnectedCommentInputContainer
              isEditing
              initialText={body}
              parentId={parentId}
              commentId={commentId}
              contentId={contentId}
              communityId={communityId}
              inputValue={inputValue}
              setInputValue={inputChangeCallBack}
              edited={hasBeenEdited}
            />
          ) : (
            <CommentText
              id="commentText"
              parentId={parentId}
              text={body}
              mentionedUsers={mentionedUsers}
            />
          )}
        </>
      </div>
    </div>
  );
};

CommentDetails.propTypes = {
  details: PropTypes.shape({
    name: PropTypes.string,
    repliedToName: PropTypes.string,
    avatar: PropTypes.string,
    userId: PropTypes.number
  }).isRequired,
  body: PropTypes.string.isRequired,
  createdAt: PropTypes.string,
  parentId: PropTypes.number,
  authorIsUser: PropTypes.bool.isRequired,
  isEditing: PropTypes.bool.isRequired,
  contentId: PropTypes.number,
  commentId: PropTypes.number,
  mentionedUsers: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      username: PropTypes.string,
      name: PropTypes.string
    })
  ).isRequired,
  communityId: PropTypes.number.isRequired
};

CommentDetails.defaultProps = {
  createdAt: null,
  parentId: null,
  contentId: null,
  commentId: null
};

export default CommentDetails;
